// import * as actions from '../Login/authenticationActions';
//Saves authObj to localstorage when user logs in
export default () => next => action => {
	// if (action.type === actions.USER_AUTH_UPDATE){
	// 	//calculate expiration datetime
	// 	var secondsToExpiration = action.authObject.expires_in;
	// 	var currentDate = new Date()
	// 	var expirationDate = currentDate.setTime(currentDate.getTime() + (secondsToExpiration*1000));
	// 	action.authObject.expirationDate = expirationDate;
	// 	action.authObject.username = action.username;
	// 	localStorage.setItem('userAuth', JSON.stringify(action.authObject));
	// }
  return next(action)
}



// WEBPACK FOOTER //
// ./src/App/MainClient/authenticationMiddleware.js